<template>
  <div class="new-chat-name-section mr-4">
    <multi-avatar class="ml-3" :users="selectedContacts" />
    <div class="new-chat-name-section__name">
      <p class="new-chat-name-section__label">Subject</p>
      <bh-text-input
        :no-margin="true"
        higher
        inputBackgroundClass="bhGray6"
        :value="value"
        roundedClass="rounded"
        :max-length="maxLength"
        :readonly="contactSingleSelection"
        @input-text="$emit('chat-subject', $event)" />
    </div>
  </div>
</template>

<script>
import BhTextInput from "@/components/inputs/BhTextInput.vue"
import MultiAvatar from '@/components/avatars/MultiAvatar'

export default {
  name: 'NewChatNameSection',
  components: {
    BhTextInput,
    MultiAvatar
  },
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    maxLength: {
      type: Number,
      default: 100
    },
    value: {
      type: [String, Number],
      default: ''
    },
    selectedContacts: {
      type: Array,
      default: () => []
    },
    currentChannelData: {
      type: Object,
      default: () => ({})
    },
    contactSingleSelection: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
@import "@/styles/mixins.scss";

.new-chat-name-section {
  display: flex;
  align-items: flex-end;

  &__name {
    flex: 1;
    margin-left: $gutter;
  }

  &__label {
    color: $bh-gray--2;
    margin-bottom: 0.125*$gutter;
    font-weight: bold;
  }
  @include imageAvatar($class-name: 'new-chat-name-section');
}
</style>
